export default "__VITE_ASSET__4f28f3a2__"